// eslint-disable-next-line @typescript-eslint/no-empty-function,@typescript-eslint/explicit-module-boundary-types,@typescript-eslint/no-unused-vars,@typescript-eslint/no-explicit-any
export const noop = (params?: any): void => {}

export function timeout(ms: number): Promise<() => number> {
  return new Promise((resolve) => setTimeout(resolve, ms))
}
